<div class="top-section">
    <div class="flex items-center">
        <app-svg name="hamburger" class="common-hamburger" (click)="ss.toggleSidebar()" role="button"
            [color]="ss.theme().color8" *ngIf="!cc.isNarrowScreen()"></app-svg>
        <h4 class="heading mb-0">{{ ss.t('features_title') }}</h4>
    </div>
    <div class="flex items-center gap-6">
        <app-notification [iconColor]="cc.isNarrowScreen() ? ss.theme().color12 : null"></app-notification>
        <app-svg name="close" role="button" (click)="navigateToToday()"
            [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
    </div>
</div>

<div class="body-section">
    <div class="feature-block">
        <div class="feature-data flex items-start ri-px-4 ri-py-4 entity-block"
            *ngFor="let feature of sortedFeatures(); let i = index;" role="button" (click)="openFeatureSetup(feature)">
            <app-svg [name]="feature.syncStatus === 'error' ? 'importantAlert' : feature.icon"
                [ngClass]="feature.icon === 'list' ||  feature.icon == 'habit'? 'icon-mirror-rtl' : ''" [color]="
                feature.syncStatus === 'error' ? ss.theme().color14 : ss.theme().color35" width="18px"
                height="18px"></app-svg>
            <div class="content w-full flex justify-between ri-ps-3"
                [ngClass]="feature.uid && feature.uid === cc.user.uid && ss.isInGracePeriod() ? 'items-center' : 'items-start'">
                <div class="flex flex-col gap-2">
                    <div class="flex items-center">
                        <app-me-user-avatar [uid]="feature.uid" size="small" class="ri-me-2"
                            *ngIf="feature.uid && feature.uid !== cc.user.uid"></app-me-user-avatar>
                        <span class="text-16-500 color-35 mb-0">{{ feature.title }}</span>
                    </div>
                    <p class="text-16-400 color-8">{{ feature.description }}</p>
                    <div class="flex gap-4">
                        <div class="inline-flex items-center gap-1.5" *ngIf="feature.entityName === 'moneyTracker'">
                            <app-svg name="moneyTracker" [color]="ss.theme().color7" width="12" height="12"></app-svg>
                            <span class="text-12-400 color-7">{{ feature.symbol }}</span>
                        </div>
                        <div class="inline-flex items-center gap-1.5"
                            *ngIf="(feature.entityName === 'journal' || feature.entityName === 'habit' || feature.entityName === 'focus') && getDuration(feature.startDate, feature.endDate, feature.repeat)">
                            <app-svg name="calendar" [color]="ss.theme().color7" width="12" height="12"></app-svg>
                            <span class="text-12-400 color-7">{{ getDuration(feature.startDate, feature.endDate,
                                feature.repeat) }}</span>
                        </div>
                        <div class="inline-flex items-center gap-1.5"
                            *ngIf="(feature.entityName === 'journal' || feature.entityName === 'habit' || feature.entityName==='moneyTracker' || feature.entityName === 'focus') && collabCount(feature.entity?.members)">
                            <app-svg name="users" [color]="ss.theme().color7" width="14" height="14"></app-svg>
                            <span class="text-12-400 color-7">{{ collabCount(feature.entity?.members) }}</span>
                        </div>
                    </div>
                </div>
                <app-svg name="importantMark" [color]="ss.theme().color14" width="20px" height="20px"
                    *ngIf="feature.uid && feature.uid === cc.user.uid && ss.isInGracePeriod()" role="button"
                    (click)="ds.featureExpiringSoon(); $event.stopPropagation()"></app-svg>
                <app-input-toggle class="toggle-top-align" [value]="feature.enabled" [readonly]="true"
                    (toggle)="toggleChange(feature, $event)" (click)="$event.stopPropagation()"
                    [confirm]="confirmConfig[feature.entityName] || null"
                    *ngIf="feature.uid !== cc.user.uid || !ss.isInGracePeriod()"></app-input-toggle>
            </div>
        </div>

        <div class="no-result-block h-full flex items-center justify-center flex-col"
            *ngIf="sortedFeatures().length === 0">
            <app-no-result-block [placeholder]="'common_noResultFound'" [imagePlaceholder]="'searchPlaceholder'"
                [showQuickGuide]="false"></app-no-result-block>
        </div>
        <div class="extra-block" *ngIf="sortedFeatures().length > 0"></div>
    </div>
</div>

<div class="add-button">
    <button class="btn" (click)="addFeatures()"><app-svg name="plus"></app-svg></button>
</div>